import { Portal } from '@radix-ui/react-context-menu'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface ContextMenuPortalProps extends ComponentPropsWithoutRef<
  typeof Portal
> {
  forceMount?: true
  container?: HTMLElement
  children: ReactNode
}

export const ContextMenuPortal = Portal
